<template>
  <div>
    <div class="card">
      <header class="header-card">
        <p>{{ $t('modificationOrdreTravailAffichage.informations.title')}}</p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-3">
            <b-field :label="$t('modificationOrdreTravailAffichage.informations.listeAffichage')"
                     custom-class="has-text-default is-italic is-marginless has-text-weight-light">
              <p class="has-text-weight-bold">{{ ordreTravail.tourneeAffichage }}</p>
            </b-field>
          </div>
          <div class="column" :class="'is-2'">
            <b-field :label="$t('modificationOrdreTravailAffichage.informations.afficheur')"
                     custom-class="has-text-default is-italic is-marginless has-text-weight-light">
              <p class="has-text-weight-bold">{{ ordreTravail.afficheur }}</p>
            </b-field>
          </div>
          <div class="column is-2 mgt-20px" >
            <a class="button is-addOrEdit" @click="editAfficheur = true">
              {{ $t('modificationOrdreTravailAffichage.informations.modificationAfficheur') }}
            </a>
          </div>
          <div class="column is-2">
            <b-field :label="$t('modificationOrdreTravailAffichage.informations.dateDepart')"
                     custom-class="has-text-default is-italic is-marginless has-text-weight-light">
              <b-datepicker show-week-number
                    nearby-selectable-month-days
                    v-model="ordreTravail.dateDepart"
                    icon="calendar-today"
                    :editable="true"
                    @input="dateChanged">
                  </b-datepicker>
            </b-field>
          </div>

          <div class="column is-1">
            <b-field :label="$t('modificationOrdreTravailAffichage.informations.etat')"
                     custom-class="has-text-default is-italic is-marginless has-text-weight-light">
              <p class="has-text-weight-bold">{{ $t(getLibelleEtat) }}</p>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field :label="$t('modificationOrdreTravailAffichage.informations.commentaires')"
                     custom-class="has-text-default is-italic is-marginless has-text-weight-light">
              <b-input v-model="ordreTravail.commentaire" type="textarea" rows="3"/>
            </b-field>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="editAfficheur" has-modal-card class="modal">
      <modification-afficheur :ordre-travail="ordreTravail">
      </modification-afficheur>
    </b-modal>
  </div>
</template>

<script>
import { LISTE_ETAT_ORDRE_TRAVAIL } from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import modificationAfficheur from '@/components/logistique/ordreTravail/affichage/p_editionAfficheur';

export default {
  name: 'infoOtUpdate',
  data() {
    return {
      editAfficheur: false,
    };
  },
  props: {
    ordreTravail: {
      type: Object,
      required: true,
    },
  },
  components: {
    modificationAfficheur,
  },
  methods: {
    dateChanged(dateDepart) {
      this.$emit('otAffichageDateChange', dateDepart);
    },
  },
  computed: {
    getLibelleEtat() {
      return LISTE_ETAT_ORDRE_TRAVAIL.find((etat) => {
        return etat.code === this.ordreTravail.etat;
      }).libelle;
    },
  },
};
</script>

<style scoped>

</style>
